/** Type-scale variants, one per class in tokens/typography-scale.css. */
export const TEXT_VARIANTS = {
  h1: 'ds-h1',
  h2: 'ds-h2',
  h3: 'ds-h3',
  h4: 'ds-h4',
  h5: 'ds-h5',
  h6: 'ds-h6',
  'body-lg': 'ds-body-lg',
  'body-sm': 'ds-body-sm',
  'body-micro': 'ds-body-micro',
  'link-lg': 'ds-link-lg',
  'link-sm': 'ds-link-sm',
  mono: 'ds-mono',
} as const;

export type TextVariant = keyof typeof TEXT_VARIANTS;
